__turbopack_context__.v({
  "billing-text": "grow-with-google-sticky-footer-content-module-scss-module__srFshW__billing-text",
  "container": "grow-with-google-sticky-footer-content-module-scss-module__srFshW__container",
  "cta-button": "grow-with-google-sticky-footer-content-module-scss-module__srFshW__cta-button",
  "cta-wrapper": "grow-with-google-sticky-footer-content-module-scss-module__srFshW__cta-wrapper",
});
